import React from 'react'
import { getTranslations } from '../TranslationTemplate'

type Translations = ReturnType<typeof getTranslations>

type Props = {
  productName: string
  ingredients: string | null | undefined
  t: Translations
}

const formatIngredientsWithAllergens = (ingredients: string): string => {
  const hashtagCount = ingredients.split('##').length - 1
  const slashCount = ingredients.split('//').length - 1
  const balanced = hashtagCount === slashCount
  return ingredients
    .replaceAll('##', balanced ? '<span class="ingredients-text--with-allergen">' : '')
    .replaceAll('//', balanced ? '</span>' : '')
}

export const IngredientsBlock: React.FC<Props> = ({ productName, ingredients, t }) => (
  <div className="ingredients">
    <p className="ingredients-text">
      <b>{productName}. </b>
      {ingredients ? (
        <>
          <b>{t.ingredients}:</b>{' '}
          <span dangerouslySetInnerHTML={{ __html: formatIngredientsWithAllergens(ingredients) }} />
        </>
      ) : null}
    </p>
  </div>
)
